/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventKindPlanningFreq } from './eventKindPlanningFreq';
import type { EventKindPlanningMinAvailableSlotsRolling } from './eventKindPlanningMinAvailableSlotsRolling';

/**
 * Flexible cadence & planning requirements for planner.
 */
export interface EventKindPlanning {
  /**
   * Planning horizon / look-ahead window for planning
   * @minimum 1
   * @maximum 24
   */
  horizonMo: number;
  freq: EventKindPlanningFreq;
  /**
   * Every N weeks/months
   * @minimum 1
   */
  interval: number;
  /** Minimum available (bookable) slots within the rolling horizon window */
  minAvailableSlotsRolling?: EventKindPlanningMinAvailableSlotsRolling;
}
